const TICKETS_LEFT_MIN = 0;
const TICKETS_LEFT_MAX = 200;

const TICKETS_LEFT_TIER_0 = 0;
const TICKETS_LEFT_TIER_10 = 10;
const TICKETS_LEFT_TIER_20 = 20;
const TICKETS_LEFT_TIER_50 = 50;
const TICKETS_LEFT_TIER_100 = 100;
const TICKETS_LEFT_TIER_200 = 200;
const TICKETS_LEFT_TIER_TOP = 201;
const TICKETS_LEFT_TIERS = [
  TICKETS_LEFT_TIER_10,
  TICKETS_LEFT_TIER_20,
  TICKETS_LEFT_TIER_50,
  TICKETS_LEFT_TIER_100,
  TICKETS_LEFT_TIER_200,
  TICKETS_LEFT_TIER_TOP,
];

const TIME_TO_EVENT_TIMEFRAME = {
  TODAY: 'today',
  TOMORROW: 'tomorrow',
  THIS_WEEKEND: 'thisWeekend',
  THIS_WEEK: 'thisWeek',
  NEXT_WEEK: 'nextWeek',
  TWO_WEEKS: 'inTwoWeeks',
};

const ON_SALE_MAX_TIME = 14; // 14 days

const TICKETS_LEFT_SHORT_VARIANTS = ['left', 'available'];
const TICKETS_LEFT_LONG_VARIANTS = ['left-site', 'available-site'];
const TICKETS_LEFT_VARIANTS = [...TICKETS_LEFT_SHORT_VARIANTS, ...TICKETS_LEFT_LONG_VARIANTS];

export {
  TICKETS_LEFT_MIN,
  TICKETS_LEFT_MAX,
  TICKETS_LEFT_TIERS,
  TICKETS_LEFT_TIER_0,
  TICKETS_LEFT_TIER_10,
  TICKETS_LEFT_TIER_20,
  TICKETS_LEFT_TIER_50,
  TICKETS_LEFT_TIER_100,
  TICKETS_LEFT_TIER_200,
  TICKETS_LEFT_TIER_TOP,
  TIME_TO_EVENT_TIMEFRAME,
  ON_SALE_MAX_TIME,
  TICKETS_LEFT_VARIANTS,
  TICKETS_LEFT_SHORT_VARIANTS,
  TICKETS_LEFT_LONG_VARIANTS,
};
